module.exports = __webpack_public_path__ + "img/wide.fe0d6f59.jpg";